jQuery(document).ready(function($){
    $(document.body).removeClass('no-js').addClass('js');

    initPolyfills();

    // Utilities
    initHeader();
    initClassToggle();
    initPolyfills();
    initAnchorScroll();
    //initFullheightMobile();
    //initParallax();
    fullcoverVideos();
    $(window).resize(fullcoverVideos);
    initInViewAnimation();
    initInViewAnimationHeading();
    $(window).resize(initInViewAnimation);
    $(window).resize(initInViewAnimationHeading);
    initSlick();
    
 
    var sectionScrolls = $('[data-section-scroll]');
    sectionScrolls.each(function() {
        var el = $(this);
        var ignoreHeader = el.is('[data-scroll-ignore-header]');

        el.on('click', function(e) {
            var parentSection = el.closest('section');
            if(parentSection.length) {
                var nextSection = parentSection.nextAll('section:first');

                if(nextSection.length) {
                    var header = $('header');
                    var scrollTopVal = nextSection.offset().top;

                    if(header.length && !ignoreHeader) {
                        scrollTopVal = scrollTopVal - header.outerHeight();
                    }

                    $('html, body').animate({
                        scrollTop: scrollTopVal
                    }, 1000);
                }
            }
            e.preventDefault();
            e.stopPropagation();
        });
    })

});
$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    
     //>=, not <=
    if (scroll >= 84) {
        //clearHeader, not clearheader - caps H
       $('.module__homepage-hero').addClass('section-reframe');
    }else {
       $('.module__homepage-hero').removeClass('section-reframe');  
    }
}); 
function initHeader() {
    const stickyElem = document.querySelector(".site-header");
     
    /* Gets the amount of height
    of the element from the
    viewport and adds the
    pageYOffset to get the height
    relative to the page */
    const currStickyPos = stickyElem.getBoundingClientRect().top + window.pageYOffset;
    window.onscroll = function() {
         
        /* Check if the current Y offset
        is greater than the position of
        the element */
        if(window.pageYOffset > currStickyPos) {
            stickyElem.style.position = "fixed";
            stickyElem.classList.add('site-header__fixed');
            stickyElem.style.top = "0px";
           
        } else {
            stickyElem.style.position = "relative";
            stickyElem.style.top = "initial";
            stickyElem.classList.remove('site-header__fixed');
        }
    }
}



function isMobile() {
    return window.matchMedia('(max-width:767px)').matches;
}



function initPolyfills() {
    // CSS object-fit for IE
    objectFitImages();

    // polyfill for IE - startsWith
    if (!String.prototype.startsWith) {
        String.prototype.startsWith = function(searchString, position) {
            position = position || 0;
            return this.indexOf(searchString, position) === position;
        };
    }

    // polyfill for IE - forEach
    if ('NodeList' in window && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = function (callback, thisArg) {
          thisArg = thisArg || window;
          for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
          }
        };
    }
}


/**
 * Toggle class on click
 */
function initClassToggle() {
    $(document.body).on('click', '[data-toggle="class"][data-class]', function(event) {
        event.preventDefault();
        
        var $trigger = $(this);
        var $target = $($trigger.data('target') ? $trigger.data('target') : $trigger.attr('href'));
        
        if($target.length) {
            event.stopPropagation();
            $target.toggleClass($trigger.data('class'));
            $trigger.toggleClass('classed');
            $('body').toggleClass('scroll-hidden');
            $('body.home').toggleClass('header-home-fixed');
            $('body.home header').toggleClass('site-header__fixed');
        }
    });
}


/**
 * Smooth anchor scrolling
 */
function initAnchorScroll() {
    $('a[href*="#"]:not([data-toggle])').click(function(event) {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name="'+this.hash.slice(1)+'"]');
            if (target.length && !target.parents('.woocommerce-tabs').length) {
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000);
            }
        }
    });

    
}


/*function initFullheightMobile() {
    // Fix mobile 100vh change on address bar show/hide
    var lastHeight = $(window).height();
    var heightChangeTimeout = undefined;
    if(isMobile()) {
        $('.vh').css('height', lastHeight);
    }
    (maybe_update_landing_height = function() {
        var winHeight = $(window).height();

        if(heightChangeTimeout !== undefined) {
            clearTimeout(heightChangeTimeout);
        }

        if(!isMobile()) {
            $('.vh').css('height', '');
        }
        else if(Math.abs(winHeight - lastHeight) > 100) {
            heightChangeTimeout = setTimeout(function() {
                var winHeight = $(window).height();
                $('.vh').css('height', winHeight);
                lastHeight = winHeight;
            }, 50);
        }
    })();
    $(window).resize(maybe_update_landing_height);
}*/

/*function initCopyToClipboard() {
  $(document.body).on('click', '[data-copy-to-clipboard]', function(event) {
    event.preventDefault();

    // Source: https://hackernoon.com/copying-text-to-clipboard-with-javascript-df4d4988697f
    var el = document.createElement('textarea');
    el.value = $(this).data('copy-to-clipboard');
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  });
}*/


function fullcoverVideos() {
    $('.landing .iframe-wrap').each(function () {
        var $container = $(this);
        var $iframe = $container.find('iframe');

        if ($iframe.length) {
            // Resize the iframe to cover the container
            cover($container, $iframe.attr('width'), $iframe.attr('height'));
        }
    });

    function cover($target, width, height) {
        var $panel = $target.parents('.landing');

        var winWidth = $panel.outerWidth();
        var winHeight = $panel.outerHeight();

        var ratio = height / width;
        var winRatio = winHeight / winWidth;

        if (winRatio > ratio) {
            $target.width(width * (winHeight / height));
            $target.height(winHeight);

            $target.css('top', 0);
            $target.css('left', (winWidth - $target.width()) / 2)
        } else {
            $target.width(winWidth);
            $target.height(height * (winWidth / width));

            $target.css('top', (winHeight - $target.height()) / 2);
            $target.css('left', 0)
        }
    }
}

function initSlick() {
    var _slider = $('#instructor-single-slider');
    _slider.slick({
        lazyLoad: 'ondemand',
        dots: false,
        infinite: true,
        arrows: true,
        autoplay: false,
        speed: 3000,
        slidesToShow: 1,
        slidesToScroll: 1,
      });
}

if(window.location.hash){
    // smooth scroll to the anchor id
    $('html,body').animate({
        scrollTop:$(window.location.hash).offset().top + 'px'
        },1000,'swing');
}


function locationInDocument(el) {
    const rect = el.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}

/**
 *
 * @param {DOM Element} element
 * @param {Percentage} offset
 */
window.isElementInViewport = function(element, offset = 0) {
    const eleTop = locationInDocument(element).top;
    const eleHeight = element.clientHeight;
    const windowTop = window.pageYOffset;

    const topOfElement = eleTop + offset * eleHeight;
    const bottomOfElement = eleTop + eleHeight;
    const bottomOfScreen = windowTop + window.innerHeight;
    const topOfScreen = windowTop;

    if (bottomOfScreen > topOfElement && topOfScreen < bottomOfElement) {
        // the element is visible, do something
        return true;
    }
    return false;
}

function initInViewAnimation() {
    if (window.matchMedia("(max-width: 1024px)").matches) {
        const $els = $('.module__wwo--hover-content');
        const defaultInViewPercent = 0.0;
        const duration = 1000;
        const easing = 'cubicBezier(.34,.615,.4,.985)';
        const defaultTranslateY = 50;
        const defaultTranslate = 'translateY';
        const supportTranslates = ['translateX', 'translateY', 'translateZ'];

        $els.each((i, el) => {
            let isElInView = false;
            const inViewOffset = $(el).attr('data-inview-percent') || defaultInViewPercent;
            // init animation
            const animeSel = '.module__wwo--hover-content__inner';
            const $animeEls = $(el).find(animeSel);
            const animeTimeline = anime.timeline({
                duration: duration,
                autoplay: false,
                easing: easing,
            });
            $animeEls.each((_, animeEl) => {
                const translate =
                    $(animeEl).attr('data-anime-translate') !== 'false'
                        ? $(animeEl).attr('data-anime-translate') || defaultTranslate
                        : false;
                const translateVal = Number($(animeEl).attr('data-anime-translate-val')) || defaultTranslateY;
                let timeOffset = Number($(animeEl).attr('data-anime-timeline')) || 0;
                timeOffset *= duration;
                let translateAnime = {};

                if (supportTranslates.includes(translate)) {
                    translateAnime = {[translate]: [translateVal, 0]}
                }
                animeTimeline.add(
                    {
                        targets: animeEl,
                        opacity: [0, 1],
                        ...translateAnime,
                    },
                    timeOffset
                );
            });

            function scrollToViewport() {
                if (isElementInViewport(el, inViewOffset) && !isElInView) {
                    isElInView = true;
                    animeTimeline.play();
                    window.removeEventListener('scroll', scrollToViewport);
                }
            }
            scrollToViewport();
            window.addEventListener('scroll', scrollToViewport);
        });
    }
}

function initInViewAnimationHeading() {
    if (window.matchMedia("(max-width: 768px)").matches) {
        const $els1 = $('.module__wwo--content-group');
        const defaultInViewPercent1 = 1;
        const duration1 = 1000;
        const easing1 = 'cubicBezier(.34,.615,.4,.985)';
        const defaultTranslateY1 = 50;
        const defaultTranslate1 = 'translateY';
        const supportTranslates1 = ['translateX', 'translateY', 'translateZ'];

        $els1.each((i, el1) => {
            let isElInView1 = false;
            const inViewOffset1 = $(el1).attr('data-inview-percent') || defaultInViewPercent1;
            // init animation
            const animeSel1 = '.module__wwo--content-group__inner';
            const $animeEls1 = $(el1).find(animeSel1);
            const animeTimeline1 = anime.timeline({
                duration: duration1,
                autoplay: false,
                easing: easing1,
            });
            $animeEls1.each((_, animeEl1) => {
                const translate1 =
                    $(animeEl1).attr('data-anime-translate') !== 'false'
                        ? $(animeEl1).attr('data-anime-translate') || defaultTranslate1
                        : false;
                const translateVal1 = Number($(animeEl1).attr('data-anime-translate-val')) || defaultTranslateY1;
                let timeOffset1 = Number($(animeEl1).attr('data-anime-timeline')) || 0;
                timeOffset1 *= duration1;
                let translateAnime1 = {};

                if (supportTranslates1.includes(translate1)) {
                    translateAnime1 = {[translate1]: [translateVal1, 0]}
                }
                animeTimeline1.add(
                    {
                        targets: animeEl1,
                        opacity: [0, 1],
                        ...translateAnime1,
                    },
                    timeOffset1
                );
            });

            function scrollToViewport() {
                if (isElementInViewport(el1, inViewOffset1) && !isElInView1) {
                    isElInView1 = true;
                    animeTimeline1.play();
                    window.removeEventListener('scroll', scrollToViewport);
                }
            }
            scrollToViewport();
            window.addEventListener('scroll', scrollToViewport);
        });
    }
}